module.exports = __webpack_public_path__ + "static/img/technology6.89dec30b.png";